export enum ELocalStorage {
  MenuCollapsed = 'menuCollapsed',
}
